const agreements = {
  consent: {
    title: "Consent to Data Processing (Opt-in 1 of 2)",
    points: [
      "I consent to Precision Health Reports collecting, using, storing, and processing my personal information, including health-related information, for the purpose of creating and delivering a personalized diagnostic health risk assessment and related reports.",
      "I understand that my information may be analyzed using proprietary models and systems and may be shared with licensed healthcare professionals or service providers engaged to support these services.",
      "I understand that my information will be processed and stored in the United States and may be transferred across national borders.",
      "I understand that I may withdraw my consent at any time by contacting Precision Health Reports, subject to legal or contractual obligations."
    ],
    checkboxLabel: "I consent to the collection and processing of my personal and health information."
  },
  diagnostic: {
    title: "Diagnostic & Informational Use Acknowledgment (Opt-in 2 of 2)",
    points: [
      "I acknowledge that the assessment provided by Precision Health Reports is diagnostic and informational only and is not medical advice, diagnosis, or treatment.",
      "I understand that no guarantees have been made regarding outcomes and that I should consult a qualified healthcare professional before making medical decisions."
    ],
    checkboxLabel: "I acknowledge the diagnostic and informational nature of this assessment."
  }
}

export default agreements;